import { KEYCODES } from '/javascripts/constants/keyCodes'
import UI from '/javascripts/utils/UI'
import setTabIndex from '/javascripts/utils/setTabIndex'
import bus from '/javascripts/bus'
import getScrollTop from '/javascripts/utils/getScrollTop'
import Hammer from 'hammerjs'
import YouTubePlayer from 'youtube-player'

UI({
  component: '.js-overviewGalleriesDetail',
  items: ['.js-overviewGalleriesDetail-item'],
  overlay: '.js-overviewGalleriesDetail-overlay',
  close: '.js-overviewGalleriesDetail-closeButton',
  prev: '.js-overviewGalleriesDetail-prevButton',
  next: '.js-overviewGalleriesDetail-nextButton',
  sliderIndicator: '.js-overviewGalleriesDetail-currentSlideIndicator',
  image: '.js-overviewGalleriesDetail-image',
  player: '.js-overviewGalleriesDetail-video',
  loader: '.js-overviewGalleriesDetail-loader'
}, ({ component, items, overlay, close, prev, next, sliderIndicator, image, player, loader }) => {
  const state = {
    activeItem: null,
    currentIndex: 0,
    totalItems: 0,
    isOpen: false,
    galleryType: null,
    isLoading: false,
    scrollTop: 0,
    hammertime: null,
    player: null
  }

  state.galleryType = component.dataset.type
  state.totalItems = items.length - 1

  if (state.galleryType === 'videos') {
    player && initializeYoutubePlayer()
  }

  close.addEventListener('click', closeOverlay)
  prev.addEventListener('click', goToPreviousItem)
  next.addEventListener('click', goToNextItem)
  image && image.addEventListener('load', onImageLoaded)
  items.forEach((item, index) => item.addEventListener('click', () => openGalleryItem(index)))

  function initializeYoutubePlayer() {
    state.player = YouTubePlayer(player.id, {
      host: 'https://www.youtube-nocookie.com', /* Is not official documented, but works fine */
      videoId: null,
      playerVars: {
        autoplay: 0,
        playsinline: 1,
        modestbranding: 1, /* Removes YouTube logo from the controls */
        rel: 0, /* Removes related video's */
        showinfo: 0 /* Removes title and uploader before video starts playing */
      }
    })
    state.player.on('stateChange', onStateChange)
  }

  function onStateChange({ data }) {
    // If video starts playing or is cued
    if (data === 1 || data === 5) {
      state.isLoading = false
      loader.classList.toggle('is-loading', state.isLoading)
    }
  }

  function openGalleryItem(index) {
    if (state.isLoading) {
      return
    }

    state.currentIndex = index
    state.activeItem = items[index]
    sliderIndicator.innerHTML = index + 1
    state.isLoading = true

    image && image.classList.toggle('is-hidden', state.isLoading)
    loader.classList.toggle('is-loading', state.isLoading)

    if (state.galleryType === 'photos') {
      const { src, srcset, sizes } = state.activeItem.dataset
      setCurrentImage(src, srcset, sizes)
    } else {
      const { youtubeid } = state.activeItem.dataset
      setCurrentVideo(youtubeid)
    }

    toggleOverlay(true)
  }

  function closeOverlay() {
    toggleOverlay(false)
  }

  function toggleOverlay(isOpen) {
    if (isOpen === state.isOpen) {
      return
    }

    state.isOpen = isOpen
    overlay.classList.toggle('is-hidden', !state.isOpen)
    bus.emit('onToggleHeader', state.isOpen)

    if (state.isOpen) {
      state.scrollTop = getScrollTop()
      document.body.style.top = `-${state.scrollTop}px`
      document.body.classList.add('is-fixed')
      setTabIndex(overlay, 0)
      document.addEventListener('keydown', onKeyPress)
      initializeHammerTime()
    } else {
      document.body.classList.remove('is-fixed')
      document.body.style.top = ''
      window.scrollTo(0, state.scrollTop)
      setTabIndex(overlay, -1)
      document.removeEventListener('keydown', onKeyPress)
      destroyHammerTime()
      state.isLoading = false
      state.player && state.player.stopVideo()
    }
  }

  function initializeHammerTime() {
    state.hammertime = new Hammer(overlay, {
      recognizers: [
        [Hammer.Rotate],
        [Hammer.Pinch, { enable: false }],
        [Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }],
      ]
    })
    state.hammertime.on('swipe', onSwipe)
  }

  function destroyHammerTime() {
    state.hammertime && state.hammertime.destroy()
    state.hammertime = null
  }

  function setCurrentImage(src, srcset, sizes) {
    if (!image) {
      return
    }

    image.src = src
    image.srcset = srcset
    image.sizes = sizes
  }

  function setCurrentVideo(youtubeid) {
    if (state.isOpen) {
      state.player.cueVideoById(youtubeid)
    } else {
      state.player.loadVideoById(youtubeid)
    }
  }

  function onImageLoaded() {
    state.isLoading = false
    image && image.classList.toggle('is-hidden', state.isLoading)
    loader.classList.toggle('is-loading', state.isLoading)
  }

  function onKeyPress(evt) {
    if (!evt.code) {
      return
    }

    if (evt.code === KEYCODES.ESC) {
      closeOverlay()
    } else if (evt.code === KEYCODES.LEFT) {
      goToPreviousItem()
    } else if (evt.code === KEYCODES.RIGHT) {
      goToNextItem()
    }
  }

  function onSwipe({ direction }) {
    if (direction === Hammer.DIRECTION_LEFT) {
      goToNextItem()
    } else if (direction === Hammer.DIRECTION_RIGHT) {
      goToPreviousItem()
    }
  }

  function goToPreviousItem() {
    prev.blur()
    const newPosition = state.currentIndex - 1 < 0 ? state.totalItems : state.currentIndex - 1
    openGalleryItem(newPosition)
  }

  function goToNextItem() {
    next.blur()
    const newPosition = state.currentIndex + 1 > state.totalItems ? 0 : state.currentIndex + 1
    openGalleryItem(newPosition)
  }
})
